import React, { useMemo, useState } from 'react';
import AllBlogPageComponent from '../../components/elements/AllBlogPage';
import { GetStaticProps } from 'next';
import { initializeApollo } from '../../utils/apollo';
import { BLOG_PAGE } from '../../queries/blog';
import { Blog, BlogsPage } from '../../types/schema';
import PageLayout, { MenuProps } from '../../layouts/Page';
import { flatten } from '../../utils/object';
import { Error, sendError } from '../../utils/error';

type AllBlogPageContainerProps = {
  blogs: Blog[];
  blogsPage: BlogsPage;
  menus: MenuProps;
  locale: string;
};

const AllBlogPageContainer: React.FC<AllBlogPageContainerProps> = ({
  blogs,
  blogsPage,
  menus,
  locale,
}) => {
  const [page, setPage] = useState(1);
  const pageSize = useMemo(() => page * 20, [page]);

  return (
    <PageLayout menus={menus} locale={locale} isHeaderTransparent>
      <AllBlogPageComponent
        metaTitle={blogsPage?.metadata?.metaTitle as string}
        metaDescription={blogsPage?.metadata?.metaDescription as string}
        metaImage={(blogsPage?.metadata?.metaImage as unknown as { url?: string })?.url as string}
        hideAppMastersTitle={blogsPage?.metadata?.hideAppMastersTitle as boolean}
        bannerImg={(blogsPage?.banner as unknown as { url?: string })?.url as string}
        language={locale}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        posts={blogs}
      />
    </PageLayout>
  );
};

/**
 * getStaticProps
 */
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  try {
    const apolloClient = initializeApollo();
    const { data } = await apolloClient.query({
      query: BLOG_PAGE,
      variables: {
        locale,
      },
    });

    const newData = flatten(data);

    return {
      props: {
        blogs: newData.allBlogs,
        blogsPage: newData.blogsPage,
        locale,
        menus: {
          header: newData.header,
          technologies: newData.technologies,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on blog index' });
    return {
      notFound: true,
    };
  }
};

export default AllBlogPageContainer;
